import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { StepIndicator } from '@gsa/afp-component-library';

export const isSolicitationSubmittable = (solicitation) => {
  return (
    !solicitation ||
    (solicitation.bidType === 'IN_FLEET' && solicitation.status === 'Draft')
  );
};

export const isSolicitationInDraft = (solicitation) => {
  return !solicitation || solicitation.status === 'Draft';
};

const SolicitationStepper = ({ currentStep, solicitation, currentBidType }) => {
  const [solicitationSteps, setSolicitationSteps] = useState([]);
  const [heading, setHeading] = useState({});
  const bidType = useMemo(() => {
    if (currentBidType) return currentBidType;
    if (solicitation) return solicitation.bidType;
    return 'IN_FLEET';
  }, [currentBidType, solicitation]);
  const allowSubmit = isSolicitationSubmittable(solicitation);
  const IN_FLEET_STEPS = [
    {
      stepID: 1,
      label: 'uPIID and details',
    },
    {
      stepID: 2,
      label: 'Open period',
    },
    {
      stepID: 3,
      label: 'Additional periods',
      status: 'not completed',
    },
    {
      stepID: 4,
      label: 'Standard Items',
      status: 'not completed',
    },
    {
      stepID: 5,
      label: 'Assign quantities',
      status: 'not completed',
    },
    {
      stepID: 6,
      label: allowSubmit ? 'Review and submit' : 'Review and close',
      status: 'not completed',
    },
  ];

  const OUTSIDE_FLEET_STEPS = [
    {
      stepID: 1,
      label: 'uPIID and details',
    },
    {
      stepID: 2,
      label: 'Standard Items',
      status: 'not completed',
    },
    {
      stepID: 3,
      label: 'Assign quantities',
      status: 'not completed',
    },
    {
      stepID: 4,
      label: allowSubmit ? 'Review and submit' : 'Review and close',
      status: 'not completed',
    },
  ];

  useEffect(() => {
    const tempSteps = [];
    if (bidType === 'IN_FLEET') {
      IN_FLEET_STEPS.forEach((step) => {
        if (step.stepID < currentStep) {
          tempSteps.push({
            label: step.label,
            status: 'completed',
          });
        } else if (step.stepID === currentStep) {
          tempSteps.push({
            label: step.label,
            status: 'current',
          });
          setHeading({
            current: step.stepID,
            text: step.label,
          });
        } else {
          // step.stepID > currentStep
          tempSteps.push({
            label: step.label,
            status: 'not completed',
          });
        }
      });
    } else if (bidType === 'OUTSIDE_FLEET') {
      OUTSIDE_FLEET_STEPS.forEach((step) => {
        if (step.stepID < currentStep) {
          tempSteps.push({
            label: step.label,
            status: 'completed',
          });
        } else if (step.stepID === currentStep) {
          tempSteps.push({
            label: step.label,
            status: 'current',
          });
          setHeading({
            current: step.stepID,
            text: step.label,
          });
        } else {
          // step.stepID > currentStep
          tempSteps.push({
            label: step.label,
            status: 'not completed',
          });
        }
      });
    }

    setSolicitationSteps(tempSteps);
  }, [currentStep, bidType, allowSubmit]);

  return (
    <>
      <StepIndicator
        counterSize="small"
        data-testid="solicitation-stepper"
        heading={heading}
        steps={[...solicitationSteps]}
        className="margin-bottom-1"
      />
      <hr className="border-gray-1" />
    </>
  );
};

SolicitationStepper.propTypes = {
  currentStep: PropTypes.number.isRequired,
  solicitation: PropTypes.object,
  currentBidType: PropTypes.string,
};

export default SolicitationStepper;
